<template>
  <svg class="spinner" viewBox="0 0 50 50" :data-spinner-location="location">
    <circle
      class="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="5"
      :stroke="strokeColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

const STROKE_COLOUR = 'var(--colour-mid-green)'

@Component({})
class LoadingSpinner extends Vue {
  @Prop({ default: STROKE_COLOUR })
  strokeColor: string

  @Prop({ default: 'unknown' })
  location: string
}

export default toNative(LoadingSpinner)
</script>

<style scoped>
.spinner {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 3s linear infinite;
  height: 1.6em;
  width: 1.6em;
}

.path {
  stroke-linecap: round;
  -webkit-animation: dash 2s ease-in-out infinite;
  animation: dash 2s ease-in-out infinite;
}

@-webkit-keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
